import { Component, ViewChild } from '@angular/core';
import {
  DATA_SERVICE_TOKEN,
  EoSearchPageComponent,
  SearchPageOptionsService,
  STATUS,
} from 'ngx-eo-web-components';
import { HospitalAvailabilityService } from '../../../../services/hospitalAvailability/hospitalAvailability.service';
import { HospitalAvailabilityFormDialogComponent } from '../hospital-availability-form-dialog/hospital-availability-form-dialog.component';
import { BehaviorSubject, filter, Subscription } from 'rxjs';
import { HospitalAvailabilitiesTableConfigBuilder } from '../../config/hospital-availability-search.config';
import {
  hospitalAvailabilitySearchFormConfig,
  initSearchForm,
} from '../../config/hospital-availability-search-form.config';
import { CoreService } from '../../../core/core.service';
import { HospitalAvailability } from '../../../core/models/hospital-availability.model';
import { AuthService } from '../../../../services/auth/auth.service';

@Component({
  selector: 'app-hospital-availability-search',
  templateUrl: './hospital-availability-search.component.html',
  styleUrl: './hospital-availability-search.component.scss',
  providers: [
    SearchPageOptionsService,
    { provide: DATA_SERVICE_TOKEN, useClass: HospitalAvailabilityService },
  ],
})
export class HospitalAvailabilitySearchComponent extends EoSearchPageComponent<HospitalAvailability> {
  @ViewChild('hospitalAvailabilityFormDialog', { static: false })
  hospitalAvailabilityFormDialog?: HospitalAvailabilityFormDialogComponent;

  data$ = new BehaviorSubject<HospitalAvailability[]>([]);
  override tableConfig = this.getHospitalAvailabilityTableConfig();

  token$ = this.authService.token$;
  tokenData = this.token$.getValue();

  protected getHospitalAvailabilityTableConfig() {
    let data = this.searchService.searchCh.data$.getValue()?.resultset ?? [];
    return new HospitalAvailabilitiesTableConfigBuilder(this.authService)
      .addFunction(
        'onEditHospitalAvailability',
        this.onEditHospitalAvailability.bind(this)
      )
      .addFunction(
        'onCreateHospitalAvailability',
        this.onCreateHospitalAvailability.bind(this)
      )
      .addHospitalAvailabilityDeleteFunction(
        this.onDeleteHospitalAvailability.bind(this)
      )
      .getTable(data);
  }

  override defaultSearchParam: {
    HospitalID: string | null;
    ClinicID: string | null;
    SortParams: any;
  } = {
    HospitalID: null,
    ClinicID: null,
    SortParams: null,
  };

  override searchParam = { ...this.defaultSearchParam };

  //override formConfig = this.authService.hasRoles(["PrivateHospitalAdmin"]) ? hospitalAvailabilitySearchFormConfig : ;

  constructor(
    override searchService: HospitalAvailabilityService,
    private coreService: CoreService,
    private authService: AuthService
  ) {
    super(searchService);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    if (this.authService.hasRoles(['PrivateHospitalAdmin'])) {
      this.formConfig = hospitalAvailabilitySearchFormConfig;
    }

    this.searchService.searchCh.data$.subscribe(() => {
      if (this.tableConfig) {
        this.tableConfig = this.getHospitalAvailabilityTableConfig();
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      initSearchForm(
        this.tokenData?.clinicId || null,
        this.authService.hasRoles(['ClinicAdmin'])
      );
    });
  }

  onEditHospitalAvailability(item: any) {
    this.hospitalAvailabilityFormDialog?.show(item);
  }

  onCreateHospitalAvailability() {
    const item = new HospitalAvailability();
    this.hospitalAvailabilityFormDialog?.show();
  }

  override isLoading(): boolean {
    return (
      this.searchService.searchCh.status$.getValue() === STATUS.loading ||
      this.searchService.hospitalAvailabilityDeleteCallHandler.status$.getValue() ===
        STATUS.loading
    );
  }
  onDeleteHospitalAvailability(
    hospitalAvailabilityId: string,
    event?: any
  ): void {
    this.confirmationService.confirm({
      target: event.target,
      header: 'ΠΡΟΣΟΧΗ!',
      message: `Είστε σίγουροι ότι θέλετε να διαγράψετε τη συγκεκριμένη διαθεσιμότητα; Η ενέργεια είναι αμετάκλητη.`,
      rejectLabel: 'Όχι',
      closeOnEscape: false,
      icon: 'pi pi-exclamation-triangle p-warning',
      acceptLabel: 'Ναι',
      rejectVisible: true,
      rejectButtonStyleClass: 'p-button-text',
      key: 'deleteHospitalAvailabilityPopup',
      accept: () => {
        return this.searchService
          .deleteHospitalAvailability(hospitalAvailabilityId)
          .subscribe(() => this.onHospitalAvailabilityDeleteSuccess());
      },
    });
  }

  private onHospitalAvailabilityDeleteSuccess() {
    this.showDeleteSuccessMessage();
    this.onSearch();
  }

  showDeleteSuccessMessage(): void {
    this.coreService.showSuccess('Η διαθεσιμότητα διαγράφηκε με επιτυχία');
  }

  onHospitalAvailabilityFormSuccess() {
    this.onSearch();
  }

  onSearch(searchParams?: any) {
    this.searchParam.HospitalID = this.tokenData?.hospitalId || null;
    this.searchParam.ClinicID =
      this.tokenData?.clinicId || searchParams?.form?.clinicID || null;

    this.searchService
      .searchHospitalAvailabilities(
        this.searchParam,
        this.getPagesize(),
        this.getPage()
      )
      .subscribe();
  }

  override getTotalCount(): number {
    return this.searchService.searchCh.data$.getValue()?.totalCount ?? 0;
  }
}
